export default __webpack_public_path__ + "static/media/make-it-rain-pdid.acce5d4b.gif";